<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">修改账户信息</div>
<div class="content" mat-dialog-content>
  <div class="part1">
    您提交的账号或密码有误，导致无法为您充值。请重新核对并提供准确信息。
  </div>
  <div class="part2">
    <div class="item">
      <div class="label">服务类型：</div>
      <div class="value value1">
        {{ data.bus.platform.name }} - {{ data.bus.bus_type.name }}
      </div>
    </div>
    <div class="item">
      <div class="label">车次编号：</div>
      <div class="value">{{ data.bus_id }}</div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="part3">
    <form [formGroup]="formGroup">
      <div class="item">
        <div class="label">您的账号</div>
        <input type="text" formControlName="username" />
      </div>
      <div class="item">
        <div class="label">您的密码</div>
        <input type="text" formControlName="password" />
      </div>
      <div class="item">
        <div class="label">备用安全码1</div>
        <input type="text" formControlName="backup_code_one" />
      </div>
      <div class="item">
        <div class="label">备用安全码2</div>
        <input type="text" formControlName="backup_code_two" />
      </div>
    </form>
  </div>
</div>
<div class="button">
  <button matRipple [disabled]="loading" (click)="close()">稍后在填</button>
  <button matRipple [disabled]="loading" (click)="onOk()">提交更新</button>
</div>
